import React, { Component } from "react";

export class WorkSpaceDescription extends Component {
    render() {
        return (
            <div className="container employer-container tab-content" id="myTabContent">
                <div
                    className="card tab-pane fade active show"
                    id="desc"
                    role="tabpanel"
                    aria-labelledby="desc-tab"
                >
                    <div className="card-header">
                        <div className="row align-items-center">
                            <div className="col">
                                <h4 className="card-header-title">
                                    Description
                                </h4>
                            </div>
                        </div>
                    </div>

                    <div className="card-body">
                        <div
                            id="JobDataContent"
                            className="list-group list-group-flush my-n3"
                        >
                            <div className="row" row="57">
                                <div className="col-12 col-xl-12">
                                    <div
                                        dangerouslySetInnerHTML={{
                                            __html: this.props.job.description
                                        }}
                                        id="JobDescreption"
                                    ></div>
                                    <div className="row">
                                        <div className="col-12 col-xl-12">
                                            <div id="badges">
                                                <hr className="my-5" />

                                                <h2 className="mb-2">
                                                    Job details
                                                    <span
                                                        id="jobNiche"
                                                        className="badge badge-soft-primary ml-1 mt-n1"
                                                    >
                                                        {" "}
                                                        {
                                                            this.props.job
                                                                .industry.name
                                                        }
                                                    </span>
                                                    <span
                                                        id="jobType"
                                                        className="badge badge-soft-primary ml-1 mt-n1"
                                                    >
                                                        {
                                                            this.props.job.type
                                                                .name
                                                        }
                                                    </span>
                                                    <span
                                                        id="jobCategory"
                                                        className="badge badge-soft-primary ml-1 mt-n1"
                                                    >
                                                        {
                                                            this.props.job
                                                                .category.name
                                                        }
                                                    </span>
                                                </h2>
                                                <p className="text-muted mb-4"></p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12 col-lg-6 col-xl">
                                            <div className="card">
                                                <div className="card-body">
                                                    <div className="row align-items-center">
                                                        <div className="col">
                                                            <h6 className="card-title text-uppercase text-muted mb-2">
                                                                Payout (USD)
                                                            </h6>

                                                            <span
                                                                id="JobPayout"
                                                                className="h2 mb-0"
                                                            >
                                                                $
                                                                {
                                                                    this.props
                                                                        .job
                                                                        .payout
                                                                }
                                                            </span>
                                                        </div>
                                                        <div className="col-auto">
                                                            <span className="h2 fe fe-dollar-sign text-muted mb-0"></span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-12 col-lg-6 col-xl">
                                            <div className="card">
                                                <div className="card-body">
                                                    <div className="row align-items-center">
                                                        <div className="col">
                                                            <h6 className="card-title text-uppercase text-muted mb-2">
                                                                Spots Available
                                                            </h6>
                                                            <span
                                                                id="JobSpots"
                                                                className="h2 mb-0"
                                                            >
                                                                {
                                                                    this.props
                                                                        .job
                                                                        .spots
                                                                }
                                                            </span>
                                                        </div>
                                                        <div className="col-auto">
                                                            <span className="h2 fe fe-briefcase text-muted mb-0"></span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-12 col-lg-6 col-xl">
                                            <div className="card">
                                                <div className="card-body">
                                                    <div className="row align-items-center">
                                                        <div className="col">
                                                            <h6 className="card-title text-uppercase text-muted mb-2">
                                                                Duration
                                                            </h6>

                                                            <span
                                                                className="h2 mb-0"
                                                                id="jobDuration"
                                                            >
                                                                {
                                                                    this.props
                                                                        .job
                                                                        .duration
                                                                        .name
                                                                }
                                                            </span>
                                                        </div>
                                                        <div className="col-auto">
                                                            <span className="h2 fe fe-clock text-muted mb-0"></span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default WorkSpaceDescription;



// WEBPACK FOOTER //
// ./src/components/employer/workSpace/WorkSpaceDescription.js